<template>
    <div>
        <ResultsTable1 :samples="samples"></ResultsTable1>

        <ResultsTable2 :samples="samples"></ResultsTable2>
    </div>
</template>

<script type="text/ecmascript-6">
    import ResultsTable1 from './ResultsTable1.vue';
    import ResultsTable2 from './ResultsTable2.vue';

    export default{
        props: {
            samples: { default() { return [] }}
        },
        components: {
            ResultsTable1,
            ResultsTable2
        },
        data () {
            return {

            }
        },
        computed: {

        },
        methods: {

        },
        mounted () {

        }
    }
</script>



// WEBPACK FOOTER //
// Results.vue?132a986a